var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#09101A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5V9.5L12.5 7.5L17.5 9.5V16.5H14.5V12.5H10.5V16.5H7.5ZM11.125 16.5V15.75H11.875V16.5H11.125ZM12.125 15V14.25H12.875V15H12.125ZM13.125 16.5V15.75H13.875V16.5H13.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseFill);
export default __webpack_public_path__ + "static/media/warehouse-fill.c9506b11048a1abe92bb8404c963ec59.svg";
export { ForwardRef as ReactComponent };